











import Vue from 'vue'

export default Vue.extend({
  name: 'NumberInput',
  props: {
    value: String,
    controls: Boolean,
    min: Number,
    max: Number,
    controlsPosition: {},
    precision: {},
    placeholder: {},
    size: {}
  },
  methods: {
    onBlur(event: UIEvent) {
      // @ts-ignore
      let value = this.filterValue(event.target.value as string)
      this.$emit('blur', value)
    },
    onInput(event: UIEvent) {
      // @ts-ignore
      let value = this.filterValue(event.target.value as string)
      this.$emit('input', value)
    },
    filterValue(event: string) {
      let value = event.toString();
      value = value.replace(/[^0-9]/gim, '');
      return value;
    }
  },
  computed: {
    currentValue: {
      get(): string {
        return this.value || ''
      },
      set() {
      }
    }
  },
})
